import VideoPlayer from 'component/VideoPlayer'
import styled from 'styled-components'

export const PageRoot = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const StyledVideoPlayer = styled(VideoPlayer)`
  margin-top: env(safe-area-inset-top);
  margin-bottom: env(safe-area-inset-bottom);
  margin-left: env(safe-area-inset-left);
  margin-right: env(safe-area-inset-right);
  height: 100%;
`

export const LoadingText = styled.div`
  font-size: 16px;
  text-align: center;
`
